import Image from "next/image";

import image from "@/images/services_hero.webp";

export default function Banner() {
  return (
    <section
      className="elementor-section elementor-top-section elementor-element elementor-element-10c4730 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
      data-id="10c4730"
      data-element_type="section"
    >
      <div className="elementor-container elementor-column-gap-no">
        <div
          className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-2c9ad8b"
          data-id="2c9ad8b"
          data-element_type="column"
        >
          <div className="elementor-widget-wrap elementor-element-populated">
            <div
              className="elementor-element elementor-element-2c60662 elementor-widget elementor-widget-image elementor-motion-effects-parent"
              data-id="2c60662"
              data-element_type="widget"
              data-settings='{"motion_fx_motion_fx_scrolling":"yes","motion_fx_scale_effect":"yes","motion_fx_scale_speed":{"unit":"px","size":2,"sizes":[]},"motion_fx_scale_range":{"unit":"%","size":"","sizes":{"start":65,"end":100}},"motion_fx_scale_direction":"out-in","motion_fx_devices":["desktop","tablet","mobile"]}'
              data-widget_type="image.default"
            >
              <div className="elementor-widget-container elementor-motion-effects-element">
                <Image
                  src={image}
                  className="attachment-full size-full"
                  alt="IS Auditr Services"
                  loading="lazy"
                  width="1728"
                  height="717"
                  sizes="100vw"
                  style={{
                    width: "100%",
                    height: "auto"
                  }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
